import React from 'react'
import Translation from '../General/Translation'


const Fsk = ({fsk, theme='', translation, setNeturalColorsForFsk}) => {
      const setNeturalColorsForFskClass = setNeturalColorsForFsk ? ' neutral-colors' : ''

    if(theme === 'Arthouse') {
        if(fsk === null || fsk === -1) {
            return <p className={"text-light fsk-label fsk" + setNeturalColorsForFskClass}><span className='fsk-text text-small-label'><Translation id="FSKnotKnown" trans={translation}>FSK noch nicht bekannt</Translation></span></p>
        } else {
            return <p className={"text-light fsk-label fsk" + setNeturalColorsForFskClass}><span className='fsk-text text-small-label' data-fsk={'FSK ' + fsk}><Translation id="fsk" trans={translation}>FSK</Translation> {fsk}</span></p>
        }
    } else {
        if(fsk === null || fsk === -1) {
            return <p className={"item-post-information fsk-label no-fsk fsk" + setNeturalColorsForFskClass}><span className='fsk-text text-medium'><Translation id="FSKnotKnown" trans={translation}>FSK noch nicht bekannt</Translation></span></p>
        } else {
            return <p className={"fsk-label fsk" + setNeturalColorsForFskClass}><span className="fsk-background"><span className='fsk-text text-medium' data-fsk={'FSK ' + fsk}><Translation id="fsk" trans={translation}>FSK</Translation> {fsk}</span></span></p>
        }
    }
}


export default Fsk